module.exports = __webpack_public_path__ + "img/badge-user-icon.0318fe3f.svg";